import * as React from 'react';
import { useState, useEffect } from 'react';
import FrameOverlay from './frameOverlay';
import './Faceplate.css';
import { IFaceplate } from './FaceplateManager';

function Faceplate(props: IFaceplate) {
    const [height, setHeight] = useState(200);
    const [width, setWidth] = useState(200);
    // const [display, setDisplay] = useState(props.display)
    const [top, setTop] = useState(props.Top);
    const [left, setLeft] = useState(props.Left);
    const [typeMove, setTypeMove] = useState(-1);
    const [TempX, setTempX] = useState(0);
    const [TempY, setTempY] = useState(0);
    const [MinWin, setMinWin] = useState({ h: 50, w: 25 });
    const [MaxWin, setMaxWin] = useState({ h: 1500, w: 1500 });
    const [title, setTitle] = useState('');

    const [inFrameOverlay, setinFrameOverlay] = useState(false);

    const previousheightRef = React.useRef<number>();
    const previousheight = previousheightRef.current;
    if (props.Height !== previousheight && props.Height !== height) {
        setHeight(props.Height);
    }

    const previouswidthRef = React.useRef<number>();
    const previouswidth = previouswidthRef.current;
    if (props.Width !== previouswidth && props.Width !== width) {
        setWidth(props.Width);
    }

    const previoustitleRef = React.useRef<string>();
    const previoustitle = previoustitleRef.current;
    if (props.title !== previoustitle && props.title !== title) {
        setTitle(props.title);
    }

    useEffect(() => {
        previouswidthRef.current = props.Width;
        previousheightRef.current = props.Height;
        previoustitleRef.current = props.title;
    });

    const OnMove = (event: MouseEvent) => {
        //  console.debug("Move:X=" + event.pageX + " Y=" + event.pageY + " typeMove=" + typeMove);
        if (typeMove > -1) {
            //console.debug("Move:X=" + event.pageX + " Y=" + event.pageY);
            switch (typeMove) {
                case 0: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewLeft = left + X;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setLeft(NewLeft);
                    setTop(NewTop);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, left: NewLeft, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 1: {
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 2: {
                    let Y = event.pageY - TempY;
                    let X = event.pageX - TempX;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;
                    let NewWidth = width + X;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setWidth(NewWidth);
                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ top: NewTop, height: NewHeight, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 3: {
                    let X = event.pageX - TempX;

                    let NewWidth = width + X;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    setWidth(NewWidth);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 4: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewWidth = width + X;
                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    setWidth(NewWidth);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ height: NewHeight, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 5: {
                    let Y = event.pageY - TempY;

                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 6: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewLeft = left + X;
                    let NewWidth = width - X;
                    let NewHeight = height + Y;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 7: {
                    let X = event.pageX - TempX;

                    let NewLeft = left + X;
                    let NewWidth = width - X;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
                case 8: {
                    let X = event.pageX - TempX;
                    let Y = event.pageY - TempY;

                    let NewTop = top + Y;
                    let NewHeight = height - Y;
                    let NewLeft = left + X;
                    let NewWidth = width - X;

                    if (NewHeight > MaxWin.h) NewHeight = MaxWin.h;
                    if (NewHeight < MinWin.h) NewHeight = MinWin.h;

                    if (NewWidth > MaxWin.w) NewWidth = MaxWin.w;
                    if (NewWidth < MinWin.w) NewWidth = MinWin.w;

                    let LeftMax = document.documentElement.clientWidth - width;
                    NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

                    let TopMax = document.documentElement.clientHeight - height;
                    NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

                    setLeft(NewLeft);
                    setWidth(NewWidth);
                    setTop(NewTop);
                    setHeight(NewHeight);
                    setTempX(event.pageX);
                    setTempY(event.pageY);
                    //this.setState({ left: NewLeft, width: NewWidth, top: NewTop, height: NewHeight, TempX: event.pageX, TempY: event.pageY });
                    break;
                }
            }
        }
    };

    const OnDownMouse = (type: number, X: number, Y: number) => {
        // console.debug("OnDownMouse " + X + ":" + Y + " ;" + type);
        setinFrameOverlay(true);

        setTypeMove(type);
        setTempX(X);
        setTempY(Y);

        const Faceplates = document.getElementsByClassName('FaceplateMainDiv');
        for (let i = 0; i < Faceplates.length; i++) {
            const slide = Faceplates[i] as HTMLElement;
            slide.style.zIndex = '45';
            slide.classList.remove('action');
        }
        const ActionFaceplates = document.getElementById(props.indexFaceplate + 'MainDiv');
        if (ActionFaceplates != null) {
            ActionFaceplates.style.zIndex = '50';
            ActionFaceplates.classList.add('action');
        }
    };

    const OnUpMouse = (event: MouseEvent) => {
        setinFrameOverlay(false);
        //console.debug("OnUpMouse");
        setTypeMove(-1);
    };

    useEffect(() => {
        let NewLeft = props.Left;
        let LeftMax = document.documentElement.clientWidth - width;
        NewLeft = NewLeft < 0 ? 0 : NewLeft > LeftMax ? LeftMax : NewLeft;

        let NewTop = props.Top;

        let TopMax = document.documentElement.clientHeight - height;
        NewTop = NewTop < 0 ? 0 : NewTop > TopMax ? TopMax : NewTop;

        setLeft(NewLeft);
        setTop(NewTop);
    }, [props.Top, props.Left, props.Width, props.Height]);

    useEffect(() => {
        if (props.CallbackRender != undefined) props.CallbackRender(props.indexFaceplate);
    }, []);

    useEffect(() => {
        document.addEventListener('mousemove', OnMove);
        document.addEventListener('mouseup', OnUpMouse);

        return () => {
            document.removeEventListener('mousemove', OnMove);
            document.removeEventListener('mouseup', OnUpMouse);
        };
    }, [typeMove]);

    return (
        <div>
            <FrameOverlay visibility={inFrameOverlay} />

            <div
                style={{
                    boxShadow: '0px 17px 14px rgba(0, 0, 0, 0.08)',
                    display: left != undefined ? 'flex' : 'hidden',
                    flexDirection: 'column',
                    position: 'absolute',
                    zIndex: 50,
                    background: '#E8F3F5',
                    height: height + 'px',
                    width: width + 'px',
                    top: top + 'px',
                    left: left + 'px'
                }}
                className="FaceplateMainDiv"
                id={props.indexFaceplate + 'MainDiv'}>
                <div style={{ display: 'flex', flexDirection: 'row', height: '2px', width: '100%', flexGrow: 0 }}>
                    <div
                        className="corner"
                        style={{ cursor: 'se-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(8, event.pageX, event.pageY);
                        }}></div>
                    <div
                        className="BorderSandN"
                        style={{ cursor: 's-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(1, event.pageX, event.pageY);
                        }}></div>
                    <div
                        className="corner"
                        style={{ cursor: 'sw-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(2, event.pageX, event.pageY);
                        }}></div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: 'calc(100% - 2px)',
                        width: '100%',
                        flexGrow: 1
                    }}>
                    <div
                        className="BorderWandE"
                        style={{ cursor: 'e-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(7, event.pageX, event.pageY);
                        }}></div>
                    <div style={{ height: '100%', width: 'calc(100% - 2px)', flexGrow: 1 }}>
                        <div className="TitleFaceplate">
                            <div
                                title={title}
                                style={{
                                    cursor: 'default',
                                    width: 'calc(100% - 20px)',
                                    height: '30px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                                onMouseDown={(event: any) => {
                                    OnDownMouse(0, event.pageX, event.pageY);
                                }}>
                                {title}
                            </div>
                            <div
                                className="TitleFaceplateClose"
                                onClick={() => {
                                    if (props.OnClose != undefined) props.OnClose();
                                }}>
                                <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.00068 4.03501L1.16155 0.190728C1.03354 0.0669619 0.862078 -0.00152229 0.684106 2.56818e-05C0.506135 0.00157365 0.335891 0.0730297 0.210042 0.199004C0.084192 0.324978 0.0128065 0.495391 0.0112601 0.673538C0.00971363 0.851685 0.0781295 1.02331 0.201773 1.15146L4.03954 4.99574L0.199058 8.83866C0.0716033 8.96624 2.23759e-09 9.13927 0 9.3197C-2.23759e-09 9.50013 0.0716033 9.67316 0.199058 9.80075C0.326513 9.92833 0.499379 10 0.679628 10C0.859876 10 1.03274 9.92833 1.1602 9.80075L5.00068 5.95647L8.8398 9.80075C8.90291 9.86392 8.97783 9.91403 9.06029 9.94822C9.14275 9.9824 9.23112 10 9.32037 10C9.40962 10 9.498 9.9824 9.58046 9.94822C9.66291 9.91403 9.73783 9.86392 9.80094 9.80075C9.86405 9.73757 9.91411 9.66258 9.94827 9.58004C9.98242 9.4975 10 9.40904 10 9.3197C10 9.23036 9.98242 9.1419 9.94827 9.05936C9.91411 8.97682 9.86405 8.90183 9.80094 8.83866L5.96046 4.99574L9.80094 1.15282C9.92459 1.02467 9.993 0.853044 9.99146 0.674897C9.98991 0.496749 9.91852 0.326337 9.79267 0.200363C9.66682 0.0743885 9.49658 0.00293243 9.31861 0.00138447C9.14064 -0.000163502 8.96918 0.0683207 8.84116 0.192087L5.00068 4.03365V4.03501Z" />
                                </svg>
                            </div>
                        </div>
                        <div style={{ background: '#fff', height: 'calc(100% - 30px)', width: 'calc(100% - 2px)' }}>
                            <iframe
                                style={{ background: '#fff', height: '100%', width: '100%' }}
                                id={props.indexFaceplate}
                                name="faceplateframe"
                                className="faceplateframe"></iframe>
                        </div>
                    </div>
                    <div
                        className="BorderWandE"
                        style={{ cursor: 'w-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(3, event.pageX, event.pageY);
                        }}></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', height: '2px', width: '100%', flexGrow: 0 }}>
                    <div
                        className="corner"
                        style={{ cursor: 'ne-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(6, event.pageX, event.pageY);
                        }}></div>
                    <div
                        className="BorderSandN"
                        style={{ cursor: 'n-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(5, event.pageX, event.pageY);
                        }}></div>
                    <div
                        className="corner"
                        style={{ cursor: 'nw-resize' }}
                        onMouseDown={(event: any) => {
                            OnDownMouse(4, event.pageX, event.pageY);
                        }}></div>
                </div>
            </div>
        </div>
    );
}

export default Faceplate;
